import { combineReducers } from 'redux';
import app from './app.reducer';
import countries from './countries.reducer';

export default combineReducers({
    app,
    countries,
});
